(function () {
  var ROOT_SELECTOR = 'product-info';
  var WIDGET_SELECTOR = '.subify-root';
  var DATA_SELECTOR = 'script[data-fs-subi-price-data]';
  var PRICE_ID_PREFIX = 'price-';
  var OPTION_SELECTOR = '.subify-minimal-option, .subify-choice-box-wrapper';
  var CUSTOM_OPTIONS_SELECTOR = '.fs-subi-purchase-options';
  var FRAGRANCE_PROPERTY_NAMES = ['Refill scent 1', 'Refill scent 2'];
  var LEGACY_FRAGRANCE_PROPERTY_NAMES = ['Bottle 1 Fragrance', 'Bottle 2 Fragrance', 'Refill Scent 1', 'Refill Scent 2'];
  var SUBSCRIPTION_TYPE_PROPERTY = 'Subscription Type';
  var SELECTED_SCENTS_PROPERTY = 'Selected Scents';
  var desiredSelections = {};

  function parseData(root) {
    var script = root.querySelector(DATA_SELECTOR);
    if (!script) return null;

    try {
      return JSON.parse(script.textContent);
    } catch (error) {
      return null;
    }
  }

  function getVariantId(root) {
    var form = getProductForm(root);
    var input = form && form.querySelector('input[name="id"]');
    return input && input.value ? input.value : null;
  }

  function getSellingPlanId(root) {
    var form = getProductForm(root);
    var input = form && form.querySelector('[name="selling_plan"]');
    return input && input.value ? input.value : '';
  }

  function getVariant(data, variantId) {
    if (!data || !variantId) return null;
    return data.variants[String(variantId)] || null;
  }

  function getActiveMode(root) {
    var customActive = root.querySelector(CUSTOM_OPTIONS_SELECTOR + ' [data-fs-purchase-option].is-active');
    if (customActive) return customActive.dataset.purchaseType === 'subscription' ? 'subscription' : 'one-time';

    var widget = root.querySelector(WIDGET_SELECTOR);
    if (!widget) return 'one-time';

    if (widget.querySelector('.subify-minimal-option:not(.one-time-purchase-option).active')) return 'subscription';
    if (widget.querySelector('.subify-choice-box-wrapper.active #subify-widget-subscription-text')) return 'subscription';
    return 'one-time';
  }

  function getActivePlan(variant, planId) {
    if (!variant || !variant.sellingPlans || !planId) return null;
    return variant.sellingPlans[String(planId)] || null;
  }

  function getPlanRecord(variant) {
    if (!variant || !variant.sellingPlans) return null;

    var planId = variant.defaultSellingPlanId ? String(variant.defaultSellingPlanId) : Object.keys(variant.sellingPlans)[0];
    var plan = planId ? variant.sellingPlans[planId] : null;
    return plan ? { id: planId, plan: plan } : null;
  }

  function getPurchaseOptions(priceData) {
    var options = {
      four: null,
      eight: null,
    };

    if (!priceData || !priceData.variants) return options;

    Object.keys(priceData.variants).forEach(function (variantId) {
      var variant = priceData.variants[variantId];
      var title = String(variant.title || '').toLowerCase();
      var planRecord = getPlanRecord(variant);
      if (!planRecord) return;

      var option = {
        variantId: String(variantId),
        variant: variant,
        planId: planRecord.id,
        plan: planRecord.plan,
      };

      if (!options.eight && (title.indexOf('8oz') !== -1 || title.indexOf('240ml') !== -1)) {
        options.eight = option;
      } else if (!options.four && (title.indexOf('4oz') !== -1 || title.indexOf('120ml') !== -1)) {
        options.four = option;
      }
    });

    return options;
  }

  function getNativeOptions(root) {
    var widget = root.querySelector(WIDGET_SELECTOR);
    if (!widget) return null;

    var subscription = widget.querySelector('.subify-minimal-option:not(.one-time-purchase-option)');
    var oneTime = widget.querySelector('.subify-minimal-option.one-time-purchase-option');

    if (!subscription || !oneTime) {
      var choiceBoxes = widget.querySelectorAll('.subify-choice-box-wrapper');
      choiceBoxes.forEach(function (choiceBox) {
        if (choiceBox.querySelector('#subify-widget-subscription-text')) subscription = choiceBox;
        if (choiceBox.querySelector('#subify-widget-one-time-purchase-text')) oneTime = choiceBox;
      });
    }

    return subscription && oneTime ? { subscription: subscription, oneTime: oneTime } : null;
  }

  function getCurrentProductTitle(root) {
    var titleNode = root.querySelector('.product__title h1') || root.querySelector('h1');
    return titleNode ? titleNode.textContent.trim() : document.title.split(' - ')[0].trim();
  }

  function createFixedBottleOne(root) {
    var field = document.createElement('div');
    field.className = 'fs-subi-fragrance-field fs-subi-fragrance-field--fixed';

    var label = document.createElement('span');
    label.className = 'fs-subi-fragrance-label';
    label.textContent = 'Bottle 1 Fragrance';

    var value = document.createElement('span');
    value.className = 'fs-subi-fragrance-fixed-value';
    value.dataset.fsBottleOneFragrance = '';
    value.textContent = getCurrentProductTitle(root);

    field.appendChild(label);
    field.appendChild(value);

    return field;
  }

  function createFragranceSelect(root, type, index) {
    var field = document.createElement('label');
    field.className = 'fs-subi-fragrance-field';

    var label = document.createElement('span');
    label.className = 'fs-subi-fragrance-label';
    label.textContent = 'Bottle ' + index + ' Fragrance';

    var selectWrap = document.createElement('span');
    selectWrap.className = 'fs-subi-fragrance-select-wrap';

    var select = document.createElement('select');
    select.className = 'fs-subi-fragrance-select';
    select.dataset.fsFragranceSelect = String(index);
    select.setAttribute('aria-label', label.textContent);

    var placeholder = document.createElement('option');
    placeholder.value = '';
    placeholder.textContent = 'Select a refill scent';
    select.appendChild(placeholder);

    var size = type === '8oz-subscription' ? '8oz' : '4oz';
    var template = root.querySelector('template[data-fs-subi-fragrance-options="' + size + '"]');
    if (template) select.insertAdjacentHTML('beforeend', template.innerHTML);

    var caret = document.createElement('span');
    caret.className = 'fs-subi-fragrance-caret';
    caret.setAttribute('aria-hidden', 'true');

    selectWrap.appendChild(select);
    selectWrap.appendChild(caret);
    field.appendChild(label);
    field.appendChild(selectWrap);

    return field;
  }

  function createPurchaseCard(root, type, title, price, badge) {
    var card = document.createElement('div');
    card.className = 'fs-subi-purchase-card';
    card.dataset.fsPurchaseOption = type;
    card.dataset.purchaseType = type === 'one-time' ? 'one-time' : 'subscription';
    card.setAttribute('role', 'radio');
    card.setAttribute('aria-checked', 'false');
    card.setAttribute('tabindex', '0');

    var radio = document.createElement('span');
    radio.className = 'fs-subi-purchase-radio';
    radio.setAttribute('aria-hidden', 'true');

    var content = document.createElement('span');
    content.className = 'fs-subi-purchase-content';

    var titleRow = document.createElement('span');
    titleRow.className = 'fs-subi-purchase-title-row';

    var titleNode = document.createElement('span');
    titleNode.className = 'fs-subi-purchase-title';
    titleNode.textContent = title;
    titleRow.appendChild(titleNode);

    if (badge) {
      var badgeNode = document.createElement('span');
      badgeNode.className = 'fs-subi-purchase-badge';
      badgeNode.textContent = badge;
      titleRow.appendChild(badgeNode);
    }

    var priceNode = document.createElement('span');
    priceNode.className = 'fs-subi-purchase-price';
    priceNode.textContent = price;

    content.appendChild(titleRow);
    card.appendChild(radio);
    card.appendChild(content);
    card.appendChild(priceNode);

    if (type !== 'one-time') {
      var fields = document.createElement('div');
      fields.className = 'fs-subi-fragrance-fields';
      fields.hidden = true;
      fields.appendChild(createFragranceSelect(root, type, 2));
      fields.insertBefore(createFixedBottleOne(root), fields.firstChild);
      card.appendChild(fields);
    }

    return card;
  }

  function setCustomActive(root, type) {
    root.querySelectorAll(CUSTOM_OPTIONS_SELECTOR + ' [data-fs-purchase-option]').forEach(function (card) {
      var active = card.dataset.fsPurchaseOption === type;
      card.classList.toggle('is-active', active);
      card.setAttribute('aria-checked', active ? 'true' : 'false');

      var fields = card.querySelector('.fs-subi-fragrance-fields');
      if (fields) fields.hidden = !active;
    });

    syncFragranceInputs(root);
  }

  function getProductForm(root) {
    return root.querySelector('form[data-type="add-to-cart-form"]') || root.querySelector('product-form form[action*="/cart/add"]');
  }

  function getOrCreatePropertyInput(form, propertyName) {
    var selector = 'input[name="properties[' + propertyName + ']"]';
    var input = form.querySelector(selector);

    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'properties[' + propertyName + ']';
      form.appendChild(input);
    }

    return input;
  }

  function getSubscriptionTypeLabel(type) {
    if (type === '8oz-subscription') return '8oz Refill Subscription';
    if (type === '4oz-subscription') return '4oz Refill Subscription';
    return '';
  }

  function getActiveCustomCard(root) {
    return root.querySelector(CUSTOM_OPTIONS_SELECTOR + ' [data-fs-purchase-option].is-active');
  }

  function syncFragranceInputs(root) {
    var form = getProductForm(root);
    var activeCard = getActiveCustomCard(root);
    if (!form || !activeCard) return;

    var isSubscription = activeCard.dataset.purchaseType === 'subscription';
    var bottleOne = activeCard.querySelector('[data-fs-bottle-one-fragrance]');
    var bottleTwo = activeCard.querySelector('[data-fs-fragrance-select="2"]');
    var subscriptionTypeInput = getOrCreatePropertyInput(form, SUBSCRIPTION_TYPE_PROPERTY);
    var selectedScentsInput = getOrCreatePropertyInput(form, SELECTED_SCENTS_PROPERTY);
    var bottleOneValue = bottleOne ? bottleOne.textContent.trim() : getCurrentProductTitle(root);
    var bottleTwoValue = bottleTwo ? bottleTwo.value : '';

    subscriptionTypeInput.value = isSubscription ? getSubscriptionTypeLabel(activeCard.dataset.fsPurchaseOption) : '';
    subscriptionTypeInput.disabled = !isSubscription;
    selectedScentsInput.value = isSubscription && bottleOneValue && bottleTwoValue ? bottleOneValue + ', ' + bottleTwoValue : '';
    selectedScentsInput.disabled = !isSubscription;

    FRAGRANCE_PROPERTY_NAMES.forEach(function (propertyName, index) {
      var input = getOrCreatePropertyInput(form, propertyName);
      input.value = '';
      if (isSubscription && index === 0) input.value = bottleOneValue;
      if (isSubscription && index === 1) input.value = bottleTwoValue;
      input.disabled = !isSubscription;
    });

    LEGACY_FRAGRANCE_PROPERTY_NAMES.forEach(function (propertyName) {
      var input = form.querySelector('input[name="properties[' + propertyName + ']"]');
      if (!input) return;
      input.value = '';
      input.disabled = true;
    });
  }

  function getFragranceError(root) {
    return root.querySelector(CUSTOM_OPTIONS_SELECTOR + ' .fs-subi-fragrance-error');
  }

  function setFragranceError(root, message) {
    var error = getFragranceError(root);
    if (!error) return;

    error.textContent = message || '';
    error.hidden = !message;
  }

  function hasRequiredFragrances(root) {
    var activeCard = getActiveCustomCard(root);
    if (!activeCard || activeCard.dataset.purchaseType !== 'subscription') return true;

    var bottleTwo = activeCard.querySelector('[data-fs-fragrance-select="2"]');
    return Boolean(bottleTwo && bottleTwo.value);
  }

  function setSellingPlanInput(root, value) {
    var form = getProductForm(root);
    if (!form) return;

    var input = form.querySelector('[name="selling_plan"]');
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'selling_plan';
      form.appendChild(input);
    }

    input.value = value || '';
    input.disabled = !value;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function selectVariant(root, option) {
    if (!option || getVariantId(root) === option.variantId) return false;

    var variantPicker = root.querySelector('variant-selects');
    if (!variantPicker) return false;

    var title = String(option.variant.title || '');
    var radios = Array.prototype.slice.call(variantPicker.querySelectorAll('input[type="radio"]'));
    var radio = radios.find(function (input) {
      return input.value === title;
    });

    if (radio) {
      radio.click();
      return true;
    }

    var selects = Array.prototype.slice.call(variantPicker.querySelectorAll('select'));
    var select = selects.find(function (candidate) {
      return Array.prototype.some.call(candidate.options, function (item) {
        return item.value === title;
      });
    });

    if (select) {
      select.value = title;
      select.dispatchEvent(new Event('change', { bubbles: true }));
      return true;
    }

    return false;
  }

  function applyDesiredSelection(root, priceData) {
    var productId = root.dataset.productId;
    var type = desiredSelections[productId];
    var nativeOptions = getNativeOptions(root);
    var options = getPurchaseOptions(priceData);
    if (!type || !nativeOptions || !options.four || !options.eight || root.fsApplyingPurchaseOption) return;

    root.fsApplyingPurchaseOption = true;

    try {
      if (type === 'one-time') {
        if (!nativeOptions.oneTime.classList.contains('active')) nativeOptions.oneTime.click();
        setSellingPlanInput(root, '');
        setCustomActive(root, type);
        return;
      }

      var selectedOption = type === '8oz-subscription' ? options.eight : options.four;
      setCustomActive(root, type);

      if (getVariantId(root) !== selectedOption.variantId) {
        selectVariant(root, selectedOption);
        return;
      }

      if (!nativeOptions.subscription.classList.contains('active')) nativeOptions.subscription.click();
      setSellingPlanInput(root, selectedOption.planId);
    } finally {
      root.fsApplyingPurchaseOption = false;
    }
  }

  function ensurePurchaseOptions(root, priceData) {
    var widget = root.querySelector(WIDGET_SELECTOR);
    var nativeOptions = getNativeOptions(root);
    var options = getPurchaseOptions(priceData);
    if (!widget || !nativeOptions || !options.four || !options.eight) return;

    var customOptions = widget.querySelector(CUSTOM_OPTIONS_SELECTOR);
    if (!customOptions) {
      customOptions = document.createElement('div');
      customOptions.className = 'fs-subi-purchase-options';
      customOptions.setAttribute('role', 'radiogroup');
      customOptions.setAttribute('aria-label', 'Choose Your Purchase Option');

      customOptions.appendChild(createPurchaseCard(root, '4oz-subscription', '4oz Subscription', options.four.plan.formattedPrice, 'Most Popular'));
      customOptions.appendChild(createPurchaseCard(root, '8oz-subscription', '8oz Subscription', options.eight.plan.formattedPrice, ''));
      customOptions.appendChild(createPurchaseCard(root, 'one-time', 'One-Time Purchase', '', ''));

      var error = document.createElement('p');
      error.className = 'fs-subi-fragrance-error';
      error.setAttribute('role', 'alert');
      error.hidden = true;
      customOptions.appendChild(error);

      var nativeContainer = nativeOptions.subscription.parentElement;
      nativeContainer.insertAdjacentElement('afterend', customOptions);
      widget.classList.add('fs-subi-three-option-mode');

      customOptions.addEventListener('click', function (event) {
        if (event.target.closest('select, option, .fs-subi-fragrance-field')) return;

        var card = event.target.closest('[data-fs-purchase-option]');
        if (!card) return;

        desiredSelections[root.dataset.productId] = card.dataset.fsPurchaseOption;
        setFragranceError(root, '');
        setCustomActive(root, card.dataset.fsPurchaseOption);
        applyDesiredSelection(root, parseData(root));
        scheduleSync(root);
      });

      customOptions.addEventListener('keydown', function (event) {
        if (event.target.matches('select')) return;
        if (event.key !== 'Enter' && event.key !== ' ') return;

        var card = event.target.closest('[data-fs-purchase-option]');
        if (!card) return;

        event.preventDefault();
        desiredSelections[root.dataset.productId] = card.dataset.fsPurchaseOption;
        setFragranceError(root, '');
        setCustomActive(root, card.dataset.fsPurchaseOption);
        applyDesiredSelection(root, parseData(root));
        scheduleSync(root);
      });

      customOptions.addEventListener('change', function (event) {
        if (!event.target.matches('[data-fs-fragrance-select]')) return;
        setFragranceError(root, '');
        syncFragranceInputs(root);
      });
    }

    var currentVariant = getVariant(priceData, getVariantId(root));
    var oneTimePrice = customOptions.querySelector('[data-fs-purchase-option="one-time"] .fs-subi-purchase-price');
    setText(oneTimePrice, currentVariant && currentVariant.formattedPrice);
    customOptions.querySelectorAll('[data-fs-bottle-one-fragrance]').forEach(function (node) {
      setText(node, getCurrentProductTitle(root));
    });

    if (!desiredSelections[root.dataset.productId]) {
      desiredSelections[root.dataset.productId] = getActiveMode(root) === 'subscription'
        ? (getVariantId(root) === options.eight.variantId ? '8oz-subscription' : '4oz-subscription')
        : 'one-time';
    }

    setCustomActive(root, desiredSelections[root.dataset.productId]);
  }

  function getSubscriptionCompare(variant, plan) {
    if (!variant || !plan) return null;

    if (variant.subscriptionCompareAtPrice && variant.subscriptionCompareAtPrice > plan.price) {
      return {
        price: variant.subscriptionCompareAtPrice,
        formattedPrice: variant.formattedSubscriptionCompareAtPrice,
      };
    }

    if (plan.compareAtPrice && plan.compareAtPrice > plan.price) {
      return {
        price: plan.compareAtPrice,
        formattedPrice: plan.formattedCompareAtPrice,
      };
    }

    return null;
  }

  function togglePriceClass(priceNode, shouldShowCompare) {
    priceNode.classList.toggle('price--on-sale', shouldShowCompare);
    priceNode.classList.remove('price--sold-out');
  }

  function setText(node, text) {
    if (node && text && node.textContent !== text) node.textContent = text;
  }

  function updateMainPrice(root, priceData) {
    var sectionId = root.dataset.section;
    var priceWrap = sectionId ? root.querySelector('#' + PRICE_ID_PREFIX + sectionId) : root.querySelector('[id^="price-"]');
    var priceNode = priceWrap && priceWrap.querySelector('.price');
    if (!priceNode) return;

    var variant = getVariant(priceData, getVariantId(root));
    if (!variant) return;

    var mode = getActiveMode(root);
    var plan = mode === 'subscription' ? getActivePlan(variant, getSellingPlanId(root)) : null;
    var current = plan || variant;
    var compare = getSubscriptionCompare(variant, plan);

    togglePriceClass(priceNode, Boolean(compare));
    setText(priceNode.querySelector('.price__regular .price-item--regular'), current.formattedPrice);
    setText(priceNode.querySelector('.price__sale .price-item--sale'), current.formattedPrice);
    setText(priceNode.querySelector('.price__sale .price-item--last'), current.formattedPrice);
    setText(priceNode.querySelector('.price__sale .price-item--regular'), compare ? compare.formattedPrice : '');
  }

  function updateSubiProductPrice(root, priceData) {
    var priceWrap = root.querySelector('[id^="price-"] .subify-product-price-wrapper');
    var variant = getVariant(priceData, getVariantId(root));
    if (!priceWrap || !variant) return;

    var mode = getActiveMode(root);
    var plan = mode === 'subscription' ? getActivePlan(variant, getSellingPlanId(root)) : null;
    var current = plan || variant;
    var compare = getSubscriptionCompare(variant, plan);
    var currentNode = priceWrap.querySelector('.subify-current-price');
    var originalNode = priceWrap.querySelector('.subify-original-price');
    var badgeNode = priceWrap.querySelector('.subify-discount-percentage');

    setText(currentNode, current.formattedPrice);

    if (compare) {
      if (!originalNode) {
        originalNode = document.createElement('span');
        originalNode.className = 'subify-original-price';
        currentNode && currentNode.insertAdjacentElement('afterend', originalNode);
      }
      setText(originalNode, compare.formattedPrice);
    } else {
      originalNode && originalNode.remove();
    }

    if (badgeNode) {
      badgeNode.style.display = plan ? '' : 'none';
    }
  }

  function updateWidgetPrices(root, priceData) {
    var widget = root.querySelector(WIDGET_SELECTOR);
    var variant = getVariant(priceData, getVariantId(root));
    if (!widget || !variant) return;

    var planId = getSellingPlanId(root);
    var plan = getActivePlan(variant, planId);
    if (!plan && variant.defaultSellingPlanId) {
      plan = getActivePlan(variant, String(variant.defaultSellingPlanId));
    }

    widget.querySelectorAll('.subify-minimal-option:not(.one-time-purchase-option) .subify-minimal-price').forEach(function (node) {
      if (plan) setText(node, plan.formattedPrice);
    });
    widget.querySelectorAll('.subify-choice-box-wrapper #subify-widget-subscription-text').forEach(function (node) {
      var card = node.closest('.subify-choice-box-wrapper');
      var price = card && card.querySelector('.subify-choice-price');
      if (plan) setText(price, plan.formattedPrice);
    });

    widget.querySelectorAll('.one-time-purchase-option .subify-minimal-price').forEach(function (node) {
      setText(node, variant.formattedPrice);
    });
    widget.querySelectorAll('.subify-choice-box-wrapper #subify-widget-one-time-purchase-text').forEach(function (node) {
      var card = node.closest('.subify-choice-box-wrapper');
      var price = card && card.querySelector('.subify-choice-price');
      setText(price, variant.formattedPrice);
    });
  }

  function sync(root) {
    var priceData = parseData(root);
    if (!priceData) return;

    window.requestAnimationFrame(function () {
      ensurePurchaseOptions(root, priceData);
      applyDesiredSelection(root, priceData);
      updateWidgetPrices(root, priceData);
      updateMainPrice(root, priceData);
      updateSubiProductPrice(root, priceData);
    });
  }

  function scheduleSync(root) {
    window.clearTimeout(root.fsSubiPriceSyncTimer);
    root.fsSubiPriceSyncTimer = window.setTimeout(function () {
      sync(root);
    }, 80);
  }

  function initRoot(root) {
    if (!root || root.fsSubiPriceSyncInitialized) return;
    if (!root.querySelector(DATA_SELECTOR)) return;

    root.fsSubiPriceSyncInitialized = true;

    root.addEventListener('submit', function (event) {
      if (event.target !== getProductForm(root)) return;
      syncFragranceInputs(root);

      if (hasRequiredFragrances(root)) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      setFragranceError(root, 'Please select your second fragrance.');

      var activeCard = getActiveCustomCard(root);
      var bottleTwo = activeCard && activeCard.querySelector('[data-fs-fragrance-select="2"]');
      if (bottleTwo) bottleTwo.focus();
    }, true);

    root.addEventListener('click', function (event) {
      if (!event.target.closest(OPTION_SELECTOR)) return;
      scheduleSync(root);
      window.setTimeout(function () {
        sync(root);
      }, 350);
    });

    root.addEventListener('change', function (event) {
      if (!event.target.matches('input[type="radio"], select, input[name="id"], [name="selling_plan"]')) return;
      scheduleSync(root);
    });

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
        if (!event || !event.data || event.data.sectionId !== root.dataset.section) return;
        scheduleSync(root);
        window.setTimeout(function () {
          sync(root);
        }, 500);
      });
    }

    if ('MutationObserver' in window) {
      var observer = new MutationObserver(function () {
        scheduleSync(root);
      });
      observer.observe(root, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['class', 'style'],
      });
    }

    scheduleSync(root);
  }

  function initAll() {
    document.querySelectorAll(ROOT_SELECTOR).forEach(initRoot);
  }

  document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('product-info:loaded', function (event) {
    initRoot(event.target);
  });
})();
